module.exports = __webpack_public_path__ + "static/img/girl-on-stage.f6c5634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/girl-on-stage.jpg
// module id = kt34
// module chunks = 1